import type { AddressSyncConfig } from "../features/questionnaire/types";

export const DEFAULT_ADDRESS_SYNC_CONFIG: AddressSyncConfig = {
  linkQuestionName: "Same correspondence address pre quote",
  linkQuestionValue: "yes",
  linkedQuestionName: "UK correspondence address lookup",
  syncMap: {
    "UK address lookup": "UK correspondence address lookup",
    address_1: "customer[address_1]",
    address_2: "customer[address_2]",
    town: "customer[town]",
    uk_postcode: "customer[uk_postcode]",
  },
};
